/* BambiNight — clone Grandi (draft) — interactions */
(function () {
  'use strict';

  /* Accordions */
  document.querySelectorAll('.cg-acc__q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.closest('.cg-acc').classList.toggle('open');
    });
  });

  /* Size guide */
  var sg = document.querySelector('.cg-sizeguide');
  if (sg) sg.addEventListener('click', function () {
    var p = document.querySelector('.cg-sizeguide-panel');
    if (p) p.classList.toggle('open');
  });

  /* Gallery thumbs */
  var mainImg = document.getElementById('cgMainMedia');
  document.querySelectorAll('.cg-thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      document.querySelectorAll('.cg-thumb').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
      if (mainImg && t.dataset.label) {
        var lbl = mainImg.querySelector('.cg-mock-label');
        if (lbl) lbl.textContent = t.dataset.label;
      }
    });
  });

  /* Kit selection */
  var kits = document.querySelectorAll('.cg-kit');
  function selectKit(kit) {
    kits.forEach(function (k) { k.classList.remove('is-selected'); });
    kit.classList.add('is-selected');
    var vid = kit.dataset.variantId;
    var vInput = document.getElementById('cgVariantId');
    if (vInput && vid) vInput.value = vid;
    var sel = document.getElementById('cgStickyVariant');
    if (sel && vid) sel.value = vid;
    var priceNow = document.getElementById('cgStickyPriceNow');
    var priceWas = document.getElementById('cgStickyPriceWas');
    if (priceNow && kit.dataset.price) priceNow.textContent = kit.dataset.price;
    if (priceWas && kit.dataset.compare) priceWas.textContent = kit.dataset.compare;
  }
  kits.forEach(function (kit) {
    kit.addEventListener('click', function () { selectKit(kit); });
  });

  /* Sticky variant dropdown -> kit cards (Einzeln existiert nur in der Sticky-Bar) */
  var stickySel = document.getElementById('cgStickyVariant');
  if (stickySel) stickySel.addEventListener('change', function () {
    var matched = false;
    kits.forEach(function (k) { if (k.dataset.variantId === stickySel.value) { selectKit(k); matched = true; } });
    if (!matched) {
      var vInput = document.getElementById('cgVariantId');
      if (vInput) vInput.value = stickySel.value;
      var opt = stickySel.options[stickySel.selectedIndex];
      var priceNow = document.getElementById('cgStickyPriceNow');
      var priceWas = document.getElementById('cgStickyPriceWas');
      if (priceNow && opt.dataset.price) priceNow.textContent = opt.dataset.price;
      if (priceWas && opt.dataset.compare) priceWas.textContent = opt.dataset.compare;
    }
  });

  /* Size pills */
  document.querySelectorAll('.cg-unit__sizes').forEach(function (grp) {
    grp.querySelectorAll('.cg-size').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        grp.querySelectorAll('.cg-size').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        var hid = grp.closest('.cg-unit').querySelector('input[type=hidden].cg-unit-size');
        if (hid) hid.value = b.textContent.trim();
      });
    });
  });
  /* Motif selects: stop card click */
  document.querySelectorAll('.cg-unit select.cg-unit-motif').forEach(function (s) {
    s.addEventListener('click', function (e) { e.stopPropagation(); });
  });

  /* Add to cart: collect unit properties */
  document.querySelectorAll('form.cg-atc-form').forEach(function (form) {
    form.addEventListener('submit', function () {
      var holder = document.getElementById('cgPropsHolder');
      if (!holder) return;
      holder.innerHTML = '';
      var kit = document.querySelector('.cg-kit.is-selected');
      if (!kit) return;
      var vInput = document.getElementById('cgVariantId');
      if (vInput && kit.dataset.variantId !== vInput.value) return; /* Einzeln via sticky: keine Kit-Eigenschaften */
      kit.querySelectorAll('.cg-unit').forEach(function (u, i) {
        var motif = u.querySelector('select.cg-unit-motif');
        var size = u.querySelector('input.cg-unit-size');
        if (motif && size) {
          var inp = document.createElement('input');
          inp.type = 'hidden';
          inp.name = 'properties[Höschen ' + (i + 1) + ']';
inp.value = motif.value + ' / Größe ' + size.value + (function(){var m={'Bagger':'BAG','Marienkäfer':'MAR','Flugzeuge':'FLU','Giraffen':'GIR','Meerestiere':'MEE','Weltraum':'WLT','Welpen':'WLP','Einhörner':'EIN','Koalas':'KOA','Melonen':'MEL','Wolkentraum':'WOL'},c='';for(var k in m){if(motif.value.indexOf(k)!==-1){c=m[k];break;}}return (c&&size.value)?(' · '+c+'-'+size.value+'-'+kit.querySelectorAll('.cg-unit').length):'';})();          holder.appendChild(inp);
        }
      });
    });
  });

  /* Mini review carousel */
  var minis = document.querySelectorAll('.cg-minireview');
  var dots = document.querySelectorAll('.cg-minidots .cg-dot');
  var idx = 0;
  function showMini(i) {
    idx = i;
    minis.forEach(function (m, j) { m.classList.toggle('is-active', j === i); });
    dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
  }
  if (minis.length) {
    dots.forEach(function (d, j) { d.addEventListener('click', function () { showMini(j); }); });
    setInterval(function () { showMini((idx + 1) % minis.length); }, 5000);
  }

  /* Sticky ATC bar visibility */
  var sticky = document.getElementById('cgStickyBar');
  var buybox = document.querySelector('.cg-buybox');
  if (sticky && buybox) {
    window.addEventListener('scroll', function () {
      var r = buybox.getBoundingClientRect();
      sticky.classList.toggle('visible', r.bottom < 0);
    }, { passive: true });
  }

  /* Scroll top */
  var st = document.getElementById('cgScrollTop');
  if (st) {
    window.addEventListener('scroll', function () {
      st.classList.toggle('visible', window.scrollY > 600);
    }, { passive: true });
    st.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* Corner gift close */
  var cg = document.getElementById('cgCornerGift');
  if (cg) {
    var x = cg.querySelector('.x');
    if (x) x.addEventListener('click', function () { cg.remove(); });
  }

  /* Compare chips (visual toggle) */
  document.querySelectorAll('.cg-chip').forEach(function (chip) {
    chip.addEventListener('click', function () {
      chip.parentElement.querySelectorAll('.cg-chip').forEach(function (c) { c.classList.remove('is-active'); });
      chip.classList.add('is-active');
    });
  });
})();
